















































































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'HistoryEv',
  // props: {
  // },
  components: {},
  setup: () => {
    return {};
  }
});
